import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { API } from "@/lib/api";
import axios from "axios";
import { Button } from "@/components/ui/button";
import { motion } from "framer-motion";
import { Phone, Loader2 } from "lucide-react";

export default function CustomerCallPage() {
  const { declineId } = useParams();
  const [data, setData] = useState(null);

  useEffect(() => {
    axios.get(`${API}/public/decline/${declineId}`).then((r) => setData(r.data)).catch(() => {});
    // Log that customer chose live person
    axios.post(`${API}/public/call-log`, { decline_id: declineId }).catch(() => {});
  }, [declineId]);

  if (!data)
    return (
      <div className="min-h-screen grid place-items-center bg-neutral-950 text-white">
        <Loader2 className="w-6 h-6 animate-spin" />
      </div>
    );

  return (
    <div
      className="min-h-screen bg-neutral-950 text-white grid place-items-center"
      style={{
        backgroundImage:
          'linear-gradient(135deg, rgba(6,15,45,0.9), rgba(6,15,45,0.65)), url("https://images.pexels.com/photos/5864155/pexels-photo-5864155.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940")',
        backgroundSize: "cover",
        backgroundPosition: "center",
      }}
    >
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        className="max-w-md w-full px-6"
      >
        <div className="backdrop-blur-xl bg-neutral-900/90 border border-white/10 rounded-lg p-8 text-center">
          <img
            src="/logo-brand.png"
            alt="Decline Drive"
            className="w-16 h-16 object-contain mx-auto mb-4"
          />
          <div className="w-16 h-16 rounded-full bg-[hsl(var(--gold))]/20 grid place-items-center mx-auto mb-5">
            <Phone className="w-7 h-7 text-[hsl(var(--gold-light))]" strokeWidth={1.75} />
          </div>
          <div className="font-mono-label text-white/60">{data.dealership_name}</div>
          <h1 className="font-display text-3xl font-bold tracking-tighter mt-2">
            Call our service team
          </h1>
          <p className="text-white/70 text-sm mt-3">
            An advisor will help you finish scheduling your recommended service.
          </p>
          {data.coupon_code && (
            <div className="mt-5 rounded-lg border-2 border-dashed border-[hsl(var(--gold))] bg-neutral-950/70 p-3" data-testid="coupon-card">
              <div className="font-mono-label text-[hsl(var(--gold-light))]">Mention your coupon</div>
              <div className="font-display text-2xl font-black tracking-tight text-[hsl(var(--gold-light))] mt-1" data-testid="coupon-code">
                {data.coupon_code}
              </div>
            </div>
          )}
          <a href={`tel:${data.dealership_phone}`} data-testid="tel-link">
            <Button className="w-full h-12 mt-6 bg-[hsl(var(--gold))] hover:bg-[hsl(var(--gold-light))] text-neutral-900 text-base font-bold">
              <Phone className="w-4 h-4 mr-2" strokeWidth={2} />
              Call {data.dealership_phone}
            </Button>
          </a>
        </div>
        <p className="text-[0.65rem] text-white/40 text-center mt-8">
          © {new Date().getFullYear()} Decline Drive™ by Ayers Enterprises
        </p>
      </motion.div>
    </div>
  );
}
